import type { Rule } from "antd/lib/form";
import type { TFunction } from "i18next";

export const passwordRequiredRule = (t: TFunction<["common"]>): Rule => ({
  required: true,
  message: t("passwordLogin.passwordRequired"),
});

export const confirmPasswordRules = (
  t: TFunction<["common"]>,
  matchField: string,
): Rule[] => [
  passwordRequiredRule(t),
  ({ getFieldValue }) => ({
    validator(_rule, value) {
      if (!value || getFieldValue(matchField) === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(t("passwordLogin.passwordsDoNotMatch")));
    },
  }),
];
